import { createSlice } from "@reduxjs/toolkit";

const orderNumberSlice = createSlice({
  name: "orderNumber",
  initialState: 0,
  reducers: {
    setOrderNumber(state, action) {
      return action.payload;
    },
    resetOrderNumber(state, action) {
      return null;
    },
  },
});

export const { setOrderNumber, resetOrderNumber } = orderNumberSlice.actions;

export default orderNumberSlice.reducer;
